const dictOptions = {
  state: {
    sex: {},
    status: {},
    crmCustType: {},
    custStatus: {},
    // custLevel: {},
    custSource: {},
    custVisitType: {},
    payMode: {},
    businessType: {},
    industry: {},
    businessTypeTree: {},
    serviceTypeTree: {},
    spStatus: {},
    contractStatus: {},
    contractType: {},
    custOrderLaunchType: {},
    contractPayMode: {},
    contractBusinessType: {},
    custBoStatus: {},
    contFileType:{},
    contIsReturn:{},
  },
  mutations: {
    //性别
    setSex(state, list) {
      state.sex = list;
    },
    setStatus(state, list) {
      state.status = list;
    },
    //客户类型
    setCrmCustType(state, list) {
      state.crmCustType = list;
    },
    setCustStatus(state, list) {
      state.custStatus = list;
    },
    // setCustLevel(state, list) {
    //   state.custLevel = list;
    // },
    setCustSource(state, list) {
      state.custSource = list;
    },
    setCustVisitType(state, list) {
      state.custVisitType = list;
    },
    //支付方式
    setPayMode(state, list) {
      state.payMode = list;
    },
    setContractPayMode(state, list) {
      state.contractPayMode = list;
    },
    //行业
    setIndustry(state,list){     
      state.industry = list;
    },
    //产品类型
    setBusinessType(state, list) {
      state.businessType = list;
    },
    //产品类型-树
    setBusinessTypeTree(state, list) {
      state.businessTypeTree = list;
    },
    setServiceTypeTree(state, list) {
      state.serviceTypeTree = list;
    },
    setSpStatus(state, list) {
      state.spStatus = list;
    },
    setContractStatus(state, list) {
      state.contractStatus = list;
    },
    setContractType(state, list) {
      state.contractType = list;
    },
    setCustOrderLaunchType(state, list) {
      state.custOrderLaunchType = list;
    },
    setContractBusinessType(state, list) {
      state.contractBusinessType = list;
    },
    setCustBoStatus(state, list) {
      state.custBoStatus = list;
    },
    setFileType(state,list){
      state.contFileType = list;
    }, 
    setIsReturn(state,list){
      state.contIsReturn = list;
    },
  }
};

export default dictOptions;
